// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
const DataVerificationReportActionTypes = {
	/****************  GET DATA VERIFICATION REPORT LIST START *********************** */
	GET_DATA_VERIFICATION_REPORT_LIST_START: 'get_data_verification_report_start',
	GET_DATA_VERIFICATION_REPORT_LIST_SUCCESS: 'get_data_verification_report_success',
	GET_DATA_VERIFICATION_REPORT_LIST_FAILURE: 'get_data_verification_report_failure',
	GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_RESET: 'get_data_verification_report_response_reset',
	GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_CHANGED:
		'get_data_verification_report_response_changed',
	/****************  GET DATA VERIFICATION REPORT LIST END *********************** */
};

export default DataVerificationReportActionTypes;
